import { useState } from 'react';
//===--- Main
import Container from "react-bootstrap/Container";
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Accordion from "react-bootstrap/Accordion";
import ProgressBar from 'react-bootstrap/ProgressBar';
//===--- Icons
import { BsFillAwardFill } from "react-icons/bs";
//===--- Data
import RewardsItems from './data/rewardsItems';
import rewardFAQs from './data/rewardsFAQs';

export default function Rewards(props) {
  const rewardQs = rewardFAQs.map( ({question, answer}) => {
    return (
      <Row>
        <div>
          <h5><strong>Q: </strong></h5>
          <p>{question}</p>
        </div>
        <div>
          <h5><strong>A: </strong></h5>
          <p>{answer}</p>
        </div>
        <hr />
    </Row>
    )
  })
  const renderRewardItems = (category) => {
    return category.map(({ title, desc }) => (
      <Col>
        <Card style={{ width: '18rem' }} className='border-0'>
          <Card.Body>
            <Card.Title>{title}</Card.Title>
            <Card.Text>{desc}</Card.Text>
          </Card.Body>
        </Card>
      </Col>
    ));
  };
  const ExclusiveOffers = renderRewardItems(RewardsItems.find(category => category.hasOwnProperty('offers1')).offers1);
  const RewardOffers = renderRewardItems(RewardsItems.find(category => category.hasOwnProperty('offers2')).offers2);
  const CheckoutOffers = renderRewardItems(RewardsItems.find(category => category.hasOwnProperty('offers3')).offers3);

  const Rewards = RewardsItems.map( ({title, sDesc, key}) => {
    return (<>
      {(key % 2 === 0) ? <>
      <div className="row-items">
        <Container className="alt-container">
          <Row>
            <h3>{title}</h3>
            <p>{sDesc}</p>
            {RewardOffers}
          </Row>
        </Container>
      </div>
      </> : <>
      <div className="row-items bg-body-tertiary alt">
        <Container className="alt-container">
          <Row>
          <h3>{title}</h3>
            <p>{sDesc}</p>
            {(key % 3) ? ExclusiveOffers : CheckoutOffers}
          </Row>
        </Container>
      </div>
        </>}</>
    )
  })
  function ScrollTo(e) {
    const elem = document.getElementById(e);
    const rect = elem.getBoundingClientRect();
    const yPos = rect.top;


    window.scrollTo(0, yPos);
  }

  return (
  <section id="rewards">
    <div className='banner'>
      <Container>
        <Col>
          {props.isSignedIn ? <>
          <h2>Welcome, {props.username}!</h2> 
          <p>You earn points on every order and get access to member exclusive perks.</p>
          <Button variant="outline-light" onClick={()=>(ScrollTo('points'))}>View Points</Button>
          </> : <>
          <h2>Join Bubblery Rewards Today!</h2>
          <p>Sign up now to earn points on every order and get access to member exclusive perks.</p>
          <Button variant="outline-light" href='#/create_account'>Sign Up</Button>
          </>}
        </Col>
        <BsFillAwardFill className="ico-reward" />
      </Container>
    </div>
      {!props.isSignedIn ? Rewards : <>
        <div className="row-items bg-body-tertiary alt">
        <Container className="alt-container">
          <Row>
          <h3>Reward Points</h3>
          {(props.progress === 100) ? 
          <p>Congratulations! You've earned a free drink on us!</p> :
          <p>You're just {100 - props.progress} points away from your next reward!</p>}
          </Row>
          <ProgressBar variant="success" now={props.progress} label={`${props.progress}%`} visuallyHidden />
        </Container>
      </div>
      </>}
    <Container className="alt-container">
      <div id='points' className='head'>
        <h3>General Rewards FAQs</h3>
      </div>
      <hr />
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="1" className='border-0'>
          <Accordion.Header></Accordion.Header>
          <Accordion.Body>
            <Col className='QnA'>
              {rewardQs}
            </Col>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </Container>
  </section>
  );
}